import {
  apiRequest,
  pensiunListparicipant,
  detailSubmission,
  pensiunInactive,
  prosesPegawai,
  generatePegawai,
} from "../../../../../services/adapters/kepegawaian/pensiunService";

class DataTableRepository {
  fetchRowTable = async (query, cancelToken) => {
    return await apiRequest(
      "get",
      pensiunListparicipant,
      {
        cancelToken: cancelToken,
        params: query,
      },
      true
    );
  };

  fetchDetailSubmission = async (query, cancelToken) => {
    return await apiRequest(
      "get",
      detailSubmission,
      {
        cancelToken: cancelToken,
        params: query,
      },
      true
    );
  };

  fetchInactive = async (query) => {
    return await apiRequest(
      "post",
      pensiunInactive,
      {
        body: query,
      },
      true
    );
  };

  fetchProcess = async (query) => {
    return await apiRequest(
      "post",
      prosesPegawai,
      {
        body: query,
      },
      true
    );
  };

  fetchGenerate = async (query) => {
    return await apiRequest(
      "post",
      generatePegawai,
      {
        body: query,
      },
      true
    );
  };
}

export default DataTableRepository;
